export const CLOUD_DEVICE_HOSTNAME = t('inference-executor');
export const DEFAULT_DEVICE_NAME = t('Default Device');
